import { CheckCircleIcon, HourglassIcon, TriangleAlertIcon } from "lucide-react";

export const VendorsAssessmentStatusLabelMap = {
  ["pending_review"]: {
    label: "New Assessment",
    borderColor: "#006FEE",
    backgroundColor: "#006FEE1A",
    renderIcon: () => {
      return <HourglassIcon size={13} />;
    },
  },
  ["in_review"]: {
    label: "In Review",
    borderColor: "#F5A524",
    backgroundColor: "#F5A5241A",
    renderIcon: () => {
      return <TriangleAlertIcon size={13} />;
    },
  },
  ["reviewed"]: {
    label: "Reviewed",
    borderColor: "#1FCB6A",
    backgroundColor: "#1FCB6A1A",
    renderIcon: () => {
      return <CheckCircleIcon size={13} />;
    },
  },
} as const;
